export interface EventBus {
	on(event: string, callback: (...args: any[]) => void): void;
	once(event: string, callback: (...args: any[]) => void): void;
	off(event: string, callback: (...args: any[]) => void): void;
	emit(event: string, ...args: any[]): void;
}

export const Events =
{
	// Define public constants for event strings
	NOTIFICATION_BAR_TOGGLED: 'notification-bar-toggle',
	NOTIFICATION_RECEIVED: 'notification-received',
	USER_LOGGED_IN: 'user-logged-in',
	USER_LOGGED_OUT: 'user-logged-out',

	// Interactive Forms Events
	INTERACTIVE_FORMS_UPDATE_REQUESTED: 'interactive-forms-update-requested',
	INTERACTIVE_FORMS_UPDATE_COMPLETE: 'interactive-forms-update-complete',
	INTERACTIVE_FORMS_SUBMIT: 'interactive-forms-submit',
	INTERACTIVE_FORMS_FAILED_VALIDATION: 'interactive-forms-failed-validation',
	INTERACTIVE_FORMS_VALIDATION_SUCCESSFUL: 'interactive-forms-validation-successful',
	INTERACTIVE_FORMS_DATACAPTURE_READY: 'interactive-forms-datacapture-ready',
	INTERACTIVE_FORMS_GENERATED: 'interactive-forms-generated',
	
	// Add more event strings as needed
}